import * as rdd from 'react-device-detect';

const devices = {
  isMobile: rdd.isMobileOnly,
  isTablet: rdd.isTablet,
  isSmartTV: rdd.isSmartTV,
  isDesktop: rdd.isDesktop,
  defaultDevice: rdd.deviceType,
};

export const getDeviceKey = () => {
  if (devices.isDesktop) {
    return 'PC';
  }
  if (devices.isTablet) {
    return 'TABLET';
  }
  if (devices.isMobile) {
    return 'MOVIL';
  }
  if (devices.isSmartTV) {
    return 'SMARTTV';
  }

  return devices.defaultDevice.toUpperCase();
};
